import React from "react";
import {
  Grid,
  Typography,
  List,
  Divider,
  ListItemButton,
  ListItemText,
  Paper,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import request from "../../../utilities/requests";

const HelpMain = ({ setTopic }) => {
  const [data, setData] = React.useState([]);
  const [query, setQuery] = React.useState("");

  React.useEffect(() => {
    const getData = async () => {
      const result = await request("help");
      if (result.success) {
        setData(result.data);
      }
    };
    getData();
  }, []);

  const filtered = React.useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return data;
    return data.filter((d) => {
      const haystack = `${d.name || ""} ${d.description || ""} ${d.topic || ""}`.toLowerCase();
      return haystack.includes(q);
    });
  }, [data, query]);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ padding: 20 }}
      direction="column"
      spacing={3}
    >
      <Grid item>
        <Typography variant="h4" align="center">
          Support
        </Typography>
      </Grid>
      <Grid item>
        <Typography align="center">
          Find videos and articles here to help you create, manage, and run your
          events
        </Typography>
      </Grid>
      <Grid item xs={12} style={{ width: "100%", maxWidth: 600 }}>
        <TextField
          fullWidth
          placeholder="Search articles..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Paper elevation={3}>
          <List>
            {filtered.length === 0 ? (
              <ListItemText
                primary={
                  <Typography align="center" color="text.secondary" style={{ padding: 16 }}>
                    No articles match "{query}".
                  </Typography>
                }
              />
            ) : (
              filtered.map((d) => (
                <React.Fragment key={d._id}>
                  <ListItemButton onClick={() => setTopic(d._id)}>
                    <ListItemText primary={d.name} secondary={d.description} />
                  </ListItemButton>
                  <Divider />
                </React.Fragment>
              ))
            )}
          </List>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default HelpMain;
